import { createRoute, redirect } from '@tanstack/react-router'

import { DashboardSkeleton } from '@shared/layouts'
import { DynamicRouteParameterWPrefix, StaticRouteParameter } from 'config/routing'
import { General, JSON } from 'domains/Workspaces/Audio/Streams/Stream'
import { Overview as StreamObjectsOverview } from 'domains/Workspaces/Audio/Streams/Stream/Objects'
import { audioStreamsRoute } from 'pages/NWPlatform/Workspaces/Workspace/Audio/Streams'
import { Structure } from 'pages/NWPlatform/Workspaces/Workspace/Audio/Streams/Stream/Structure'

export const audioStreamRoute = createRoute({
  getParentRoute: () => audioStreamsRoute,
  path: DynamicRouteParameterWPrefix.AUDIOSTREAM_ID,
  beforeLoad: ({ location, params: { audiostreamId } }) => {
    const encodedParam = encodeURIComponent(audiostreamId)
    if (location.pathname.endsWith(encodedParam) || location.pathname.endsWith(`${encodedParam}/`)) {
      throw redirect({ replace: true, from: audioStreamRoute.fullPath, to: audioStreamGeneralRoute.to })
    }
  },
  loader: () => ({
    crumb: {
      title: null,
    },
  }),
})

export const audioStreamLayoutRoute = createRoute({
  getParentRoute: () => audioStreamRoute,
  id: 'audioStreamLayout',
  component: Structure,
})

/** Gives the General tab the xl max-width and full-height container its edit mode needs. */
export const audioStreamDashboardLayoutRoute = createRoute({
  getParentRoute: () => audioStreamLayoutRoute,
  id: 'audioStreamDashboardLayout',
  component: DashboardSkeleton,
})

export const audioStreamGeneralRoute = createRoute({
  getParentRoute: () => audioStreamDashboardLayoutRoute,
  path: StaticRouteParameter.GENERAL,
  component: General,
})

export const audioStreamConfigRoute = createRoute({
  getParentRoute: () => audioStreamLayoutRoute,
  path: StaticRouteParameter.CONFIG,
  component: JSON,
})

type AudioStreamObjectsOverviewSearch = {
  query?: string
}

export const audioStreamObjectsOverviewRoute = createRoute({
  getParentRoute: () => audioStreamLayoutRoute,
  path: StaticRouteParameter.OBJECTS,
  component: StreamObjectsOverview,
  validateSearch: (search: AudioStreamObjectsOverviewSearch) => ({
    ...(search.query && { query: search.query }),
  }),
})
